module.exports = __webpack_public_path__ + "img/p21.ff488915.png";